import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._filterEl = options.filterEl;
        this._listEl = options.listEl;
        this._placeholder = options.placeholder;
        this._cta = options.cta;
        this._ctaReset = options.reset;
        this._showSiteUrl = options.showSiteUrl;
        this._categories = JSON.parse(options.categories);
        this._groupId = options.groupId;
        this._portalUrl = options.portalUrl;
        this._published = JSON.parse(options.published);
        this._tileVariant = options.tileVariant;
        this._searchString = writable("");
        this._kategorie = writable("");
        this._stav = writable("");
        this._order = writable("");
        this._orderDirection = writable("");
        this._type = writable("");
        this._types = writable([]);
    }
    resetFilter() {
        this.searchString = "";
        this.kategorie = "";
        this.stav = "";
        this.order = "";
        this.orderDirection = "";
        this.type = "";
    }
    getCategoryAttribute(categoryId, attribute) {
        if (!categoryId || !attribute) {
            return undefined;
        }
        const category = this.categories.find(item => item.id === categoryId);
        if (!category) {
            return undefined;
        }
        return category[attribute];
    }
    get isFilterActive() {
        return !!(this.kategorie || this.stav || this.searchString || this.order || this.orderDirection);
    }
    get filterEl() {
        return this._filterEl;
    }
    get listEl() {
        return this._listEl;
    }
    get placeholder() {
        return this._placeholder;
    }
    get cta() {
        return this._cta;
    }
    get ctaReset() {
        return this._ctaReset;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get categories() {
        return this._categories;
    }
    get groupId() {
        return this._groupId;
    }
    get portalUrl() {
        return this._portalUrl;
    }
    get published() {
        return this._published;
    }
    get tileVariant() {
        return this._tileVariant;
    }
    // searchString
    set searchString(string) {
        this._searchString.set(string);
    }
    get searchStringSubs() {
        return this._searchString;
    }
    get searchString() {
        return get(this._searchString);
    }
    get searchParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("q") || "";
    }
    // kategorie
    set kategorie(value) {
        this._kategorie.set(value);
    }
    get kategorie() {
        return get(this._kategorie);
    }
    // typ
    set type(value) {
        this._type.set(value);
    }
    get type() {
        return get(this._type);
    }
    get kategorieParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const kategorie = urlParams.get("kategorie");
        return kategorie && this.categories.some(item => item.id === Number(kategorie)) ? kategorie : "";
    }
    // stav
    set stav(value) {
        this._stav.set(value);
    }
    get stav() {
        return get(this._stav);
    }
    get stavParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const stav = urlParams.get("stav");
        return stav || "";
    }
    // order
    set order(value) {
        this._order.set(value);
    }
    get order() {
        return get(this._order);
    }
    get orderParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const order = urlParams.get("razeni");
        return order || "";
    }
    // order direction
    set orderDirection(value) {
        this._orderDirection.set(value);
    }
    get orderDirection() {
        return get(this._orderDirection);
    }
    get orderDirectionParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const orderDirection = urlParams.get("smer");
        return orderDirection || "";
    }
    // typ
    loadTypes() {
        this._types.set([
            { id: "VEREJNE", nazev: "Veřejné ankety" },
            { id: "BRNO_ID", nazev: "S přihlášením Brno iD" },
        ]);
        return;
    }
    get types() {
        return this._types;
    }
    // common
    get pageParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("strana");
        return page ? parseInt(page) : 1;
    }
    get pageSizeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageSize = urlParams.get("pocet");
        return pageSize ? parseInt(pageSize) : 10;
    }
}
